import ConfirmationModal from './ConfirmationModal';

const DomainSuspendResumeConfirmationModal = ({ show, running, onConfirm, close }) => {
  return (
    <ConfirmationModal
      show={show}
      close={close}
      confirm={() => onConfirm().then(close)}
      message={
        running
          ? 'After disabling this shop, campaigns, workflows and web personalizations will not run. This shop will stop incurring charges, however any outstanding charges will be charged at the end of the billing period. Your data will be kept for 14 days after which it will be permanently deleted.'
          : 'After enabling this shop, campaigns, workflows and web personalizations will run and this shop will resume incurring charges.'
      }
    />
  );
};

export default DomainSuspendResumeConfirmationModal;
